import { render, staticRenderFns } from "./BaseDonutChart.vue?vue&type=template&id=c12dca02"
import script from "./BaseDonutChart.vue?vue&type=script&lang=js"
export * from "./BaseDonutChart.vue?vue&type=script&lang=js"
import style0 from "./BaseDonutChart.vue?vue&type=style&index=0&id=c12dca02&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports